import React from 'react'
import { observer } from 'mobx-react'

import Autosuggest from 'components/autosuggest/Autosuggest'
import { IProps as ITableCellEditorParams } from './TableCellEditor'

import styles from './booleanInput.scss'

interface IProps extends ITableCellEditorParams {
  initialValue: boolean | null
}

interface IState {
  value: boolean | null
}

class BooleanInput extends React.PureComponent<IProps, IState> {
  private input: React.RefObject<any> = React.createRef()

  constructor(props: IProps) {
    super(props)

    this.state = {
      value: !!props.initialValue,
    }
  }

  // Called by ag-grid to get the final value when editing is finished
  getValue = () => this.state.value

  focus = () => {
    this.input.current?.focus()
  }

  handleChange = (value: string) => {
    this.setState({ value: value === 'true' })
  }

  handleSubmit = (value: string) => {
    this.setState({ value: value === 'true' }, () => {
      this.props.stopEditing()
    })
  }

  render() {
    const { value } = this.state

    return (
      <Autosuggest
        ref={this.input}
        dataCy="input--boolean"
        className={styles.input}
        value={value === null || value === undefined ? '' : String(value)}
        suggestions={['true', 'false']}
        onChange={this.handleChange}
        onSubmit={this.handleSubmit}
      />
    )
  }
}

export default observer(BooleanInput)
